const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
// @ commons
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
//@utilities
const { FormattedText, formatText } = require('core/i18n').i18n;
const { toCamelCase } = require('utilities/stringHelper');
const { formatCardNumber } = require('utilities/cardsHelper');
const { getFormattedString } = require('utilities/currencyHelper');
//@constants
const { FIRST_STEP, CARD_MODIFY_DEBIT_LIMITS_TYPE_COMMERCE } = require('constants/index');

class ModifyDebitLimitsSuccessStep extends React.Component {
    render() {
        const { immCard, immCardModifyDebitLimits, processType } = this.props;

        const immFirstStep = immCardModifyDebitLimits.getIn(['steps', FIRST_STEP]);
        const cardId = immCard.get('cardId');
        const cardAlias = toCamelCase(immCard.getIn(['alias', 'current']));
        const cardNumber = formatCardNumber(immCard.get('number'), 4, '*');

        const tentativeAmount = {
            amount: immFirstStep.get('limit'),
            currency: immFirstStep.get('currency')
        };

        const formattedAmount = getFormattedString(tentativeAmount);

        let title;
        if (immCardModifyDebitLimits.get('operationType') === CARD_MODIFY_DEBIT_LIMITS_TYPE_COMMERCE) {
            title = formatText('cardModifyDebitLimits-successCommerceTitle', [cardAlias, cardNumber]);
        } else {
            title = formatText('cardModifyDebitLimits-successExtractTitle', [cardAlias, cardNumber]);
        }

        const goBackButton = {
            label: formatText('cards-backToCard', [cardAlias]).toUpperCase(),
            url: `/myprofile/cards/${cardId}/details`
        };

        return (
            <div className="col-xs-12 col-md-offset-1 col-md-10 col-lg-offset-2 col-lg-8">
                <WizardSuccess
                    successMessage={title}
                    mainButton={goBackButton}
                    processType={processType}
                >
                    <section className="row no-gutter">
                        <div className="col-xs-6 col-md-7">
                            <CommercialAds path="cards" type="cards" immCard={immCard} size="medium" />
                        </div>
                        <div className="col-xs-6 col-md-5">
                            <FormattedText value="cardModifyDebitLimits-successMessage" injectedStrings={[formattedAmount]} />
                        </div>
                    </section>
                </WizardSuccess>
            </div>
        );
    }
}

ModifyDebitLimitsSuccessStep.propTypes = {
    immCard: PropTypes.object.isRequired,
    immCardModifyDebitLimits: PropTypes.object.isRequired,
    processType: PropTypes.string.isRequired,
};

module.exports = ModifyDebitLimitsSuccessStep;
